module.exports = "/_next/static/images/car-monotone-4319bbd7de1d6d5915af6b4f843f461b.svg";